export default {
  ICHLApi: {
    hotlineApi: {
      getWaitingList: 'api/hotlineApi/getWaitingList',
      exportWaitingList: 'api/hotlineApi/exportWaitingList',
      getEffectiveList: 'api/hotlineApi/getEffectiveList',
      exportEffectiveList: 'api/hotlineApi/exportEffectiveList',
      getInvalidLedgerList: 'api/hotlineApi/getInvalidLedgerList',
      del: 'api/hotlineApi/del',
      ledgerInfo: 'api/hotlineApi/ledgerInfo',
      saveOrUpdate: 'api/hotlineApi/saveOrUpdateNew',
      uploadAIInfo: 'api/hotlineApi/uploadAIInfo',
      emergencyLedger: 'api/hotlineApi/emergencyLedger',
      getCallTypeOptions: 'api/hotlineApi/getCallTypeOptions',
      popLedger: 'api/hotlineApi/popLedger',
      ledgerConInfo: 'api/hotlineApi/ledgerConInfo',
      saveCallConversationInfos: 'api/hotlineApi/saveCallConversationInfos',
      uploadConsultantInfo: 'api/hotlineApi/uploadConsultantInfo',
      getRecordLogs: 'api/hotlineApi/getRecordLogs',
      invalidData: 'api/hotlineApi/invalidData',
    },
    asrLedgerApi: {
      getTransferList: 'api/asrLedgerApi/getTransferList',
      getLedgerList: 'api/asrLedgerApi/getLedgerList',
      addASRJob: 'api/asrLedgerApi/addASRJob',
    },
    ledgerDictionaryApi: {
      allCauseTree: 'api/ledgerDictionaryApi/allCauseTree',
      addCause: 'api/ledgerDictionaryApi/addCause',
      updateCause: 'api/ledgerDictionaryApi/updateCause',
      delCause: 'api/ledgerDictionaryApi/delCause',
      causeData: 'api/ledgerDictionaryApi/causeData',
      allConsultationTypeTree: 'api/ledgerDictionaryApi/allConsultationTypeTree',
      addConsultationType: 'api/ledgerDictionaryApi/addConsultationType',
      updateConsultationType: 'api/ledgerDictionaryApi/updateConsultationType',
      delConsultationType: 'api/ledgerDictionaryApi/delConsultationType',
    },
    bussinessType: {
      bussinessTypeTree: 'api/hotlineApi/bussinessType/bussinessTypeTree',
      bussinessTypeList: 'api/hotlineApi/bussinessType/bussinessTypeList',
      addBussinessType: 'api/hotlineApi/bussinessType/addBussinessType',
      updateBussinessType: 'api/hotlineApi/bussinessType/updateBussinessType',
      delBussinessType: 'api/hotlineApi/bussinessType/delBussinessType',
      treeSelect: 'api/hotlineApi/bussinessType/treeSelect',
    },
    tag: {
      tagOptions: 'api/hotlineApi/tag/tagOptions',
      pageList: 'api/hotlineApi/tag/pageList',
      saveOrUpdate: 'api/hotlineApi/tag/saveOrUpdate',
      delTag: 'api/hotlineApi/tag/delTag',
    },
    FPSupportApi: {
      callPageList: 'api/FPSupportApi/callPageList',
      exportCallPageList: 'api/FPSupportApi/exportCallPageList',
      // 获取已存通话文本记录
      callConInfo: 'api/FPSupportApi/callConInfo',
      getRecordLogs: 'api/FPSupportApi/getRecordLogs',
      loadCallRecord: 'api/FPSupportApi/loadCallRecord',
      //// 获取通话文本记录
      callConversationInfo: 'api/FPSupportApi/callConversationInfo',
      createLedger: 'api/FPSupportApi/createLedger',
    },
    MSSupportApi: {
      getRecordList: 'api/MSSupportApi/getRecordList',
      getMSRecordConversationInfo: 'api/MSSupportApi/getMSRecordConversationInfo',
      exportRecordList: 'api/MSSupportApi/exportRecordList',
      getMSRecord: 'api/MSSupportApi/getMSRecord',
      getWaiting: 'api/MSSupportApi/getWaiting',
      grabbing: 'api/MSSupportApi/grabbing',
      getStatusOptions: 'api/MSSupportApi/getStatusOptions',
      getRecordLogs: 'api/MSSupportApi/getRecordLogs',
      createLedger: 'api/MSSupportApi/createLedger',

      //补录
      additionalRecord: 'api/MSSupportApi/additionalRecord',

      callNumberList: 'api/MSSupportApi/callNumberList',
      addCallNumber: 'api/MSSupportApi/addCallNumber',
      updateCallNumber: 'api/MSSupportApi/updateCallNumber',
      delCallNumbers: 'api/MSSupportApi/delCallNumbers',
      // 关闭咨询件
      closeMSRecord: 'api/MSDockingApi/closeMSRecord',
      // 上报异常件
      reportMSRecordError: 'api/MSDockingApi/reportMSRecordError'
    }
  }
}
